<script setup lang="ts">

const props = defineProps({
  path: String,
})

const route = useRoute()
const toast = useToast()
const { copy, copied } = useClipboard()
const site = useSiteConfig()
const appConfig = useAppConfig()

// const mdPath = computed(() => `${site.url}/raw${route.path}.md`)
const mdPath = computed(() => `https://gitlab.com/eu-os/eu-os.gitlab.io/-/raw/main/content/${props.path}?ref_type=heads`)
const aiPrompt = computed(() => `I'm looking at this EU OS documentation: https://gitlab.com/eu-os/eu-os.gitlab.io/-/raw/main/content/${props.path}\nHelp me understand how to use it. Be ready to explain concepts, give examples, or help debug based on it.`)

const items = [
  {
    label: 'Copy Markdown link',
    icon: 'i-lucide-link',
    onSelect() {
      copy(mdPath.value)
      toast.add({
        title: 'Copied to clipboard',
        icon: 'i-lucide-check-circle'
      })
    }
  },
  {
    label: 'View as Markdown',
    icon: 'i-simple-icons:markdown',
    target: '_blank',
    to: mdPath.value,
  },
  {
    label: 'Open in ChatGPT',
    icon: 'i-simple-icons:openai',
    target: '_blank',
    to: `https://chatgpt.com/?prompt=${encodeURIComponent(aiPrompt.value)}`,
  },
  {
    label: 'Open in Claude',
    icon: 'i-simple-icons:anthropic',
    target: '_blank',
    to: `https://claude.ai/new?q=${encodeURIComponent(aiPrompt.value)}`,
  },
  {
    label: 'Open in Duck.ai',
    icon: 'i-simple-icons:duckduckgo',
    target: '_blank',
    to: `https://duckduckgo.com/?t=ffab&q=${encodeURIComponent('!ai '+aiPrompt.value)}`,
  },
]

async function copyPage() {
  let filePath = encodeURIComponent(`content/${props.path}`)
  let source = `https://gitlab.com/api/v4/projects/65688105/repository/files/${filePath}?ref=main`
  console.log(source)
  let fileObj = await $fetch<string>(source)
  copy(atob(fileObj.content))
  toast.add({
    title: 'Copied to clipboard',
    icon: 'i-lucide-check-circle'
  })
}
</script>

<template>
  <UFieldGroup>
    <UButton
      label="Copy page"
      :icon="copied ? appConfig.ui.icons.copyCheck : appConfig.ui.icons.copy"
      color="neutral"
      variant="outline"
      :ui="{
        leadingIcon: [copied ? 'text-primary' : 'text-neutral', 'size-3.5']
      }"
      @click="copyPage"
    />
    <UDropdownMenu
      :items="items"
      :content="{
        align: 'end',
        side: 'bottom',
        sideOffset: 8
      }"
      :ui="{
        content: 'w-48'
      }"
    >
      <UButton
        :icon="appConfig.ui.icons.chevronDown"
        size="sm"
        color="neutral"
        variant="outline"
        aria-label="Open copy actions menu"
      />
    </UDropdownMenu>
  </UFieldGroup>
</template>
